const store = {
    store: () => `admin/store`,
    storeByID: (id: string) => `admin/store/${id}`,
    storeStatus: (id: string) => `admin/store/${id}/status`,
    storeImages: () => `admin/store/images`,
    storeCount: () => `admin/store/count`,
    changePassword: () => `admin/user/change-password`,
    searchUser: (userID: string) => `admin/search/${userID}`,
    searchStoreLocation: () => 'admin/store/location-search',
    // for store staff and subAdmin list
    storeStaffSubAdmin:(id:string)=>`admin/store/staff/${id}`,
    deleteStoreStaffSubAdmin:({store_id,staff_id}:{store_id:string,staff_id:string})=>`admin/store/${store_id}/staff/${staff_id}`,
    ecomStatus:(id:string)=>`admin/store/${id}/status`

}
export default store 